<!-- eslint-disable no-unused-vars -->
<template>
  <div class="service-dynamic">
    <div class="wrap-aside">
      <!-- <div class="aside-title">
            <span>动态</span>
          </div> -->
      <div class="flow">
        <ul>
          <li v-for="(item, index) in orderLog" :key="index">
            <div class="ub tit ub-xc">
              <div class="dit1" :class="{ dit: index === 0 }">
                <div></div>
              </div>
              <h1>{{ momentAmPm($momentLocal(item.gmtCreate)) }}</h1>
            </div>
            <div>
              <p>{{ $t('asm_service_dynamic.ding_dan_zhuang_tai') }}：{{ getDicValue('asm_case_order_state', item.caseOrderState) || '-' }}</p>
              <p>{{ $t('asm_service_dynamic.miao_shu') }}：{{ item.langStateDescView || '-' }}</p>
              <p>{{ $t('asm_service_dynamic.cao_zuo_ren') }}：{{ item.creator || '-' }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="workOrderId" class="map-content" ref="content" id="container"></div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

var map;
var showInfoWindow;
var languageMap = {
  // langcode映射谷歌地图language
  CN: 'zh-CN',
  EN: 'en-hk',
};
var pi = 3.14159265358979324;
var a = 6378245.0;
var ee = 0.00669342162296594323;

const noop = function () {};

/**
 * 服务动态
 */
export default {
  name: '',
  mixins: [],
  props: {
    caseOrderId: [Number, String],
    workOrderId: [Number, String],
    showMap: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
    },
  },
  data() {
    return {
      orderLog: [],

      mapType: '', // 1-高德   4-谷歌
      mapRegion: '', // 谷歌地图 本地化区域
      mapLanguage: '', // 谷歌地图 地图多语言,
    };
  },
  computed: {
    typeMap() {
      return {
        start: this.$t('asm_service_dynamic.chu_fa'),
        arrive: this.$t('asm_service_dynamic.dao_da'),
        solve: this.$t('asm_service_dynamic.jie_jue'),
        device: this.$t('asm_service_dynamic.ji_qi'),
      };
    },
  },

  methods: {
    getStateList() {
      this.$getJSON(apis.caseOrderStateList, { caseOrderId: this.caseOrderId }).then((res) => {
        this.orderLog = res.data || [];
      });
    },
    initMap(cb) {
      if (`${this.mapType}` === '4') {
        this.inintGoogleMap(cb);
      } else if (`${this.mapType}` === '1') {
        this.initAMap(cb);
      }
    },
    // 初始化(高德地图)
    initAMap(cb) {
      const callback = cb || noop;
      const { center } = this.$getAMapCenterZoom();
      if (window.AMap) {
        map = new window.AMap.Map('container', {
          center,
          zoom: 20,
          mapStyle: 'amap://styles/whitesmoke',
        });
        callback();
        return;
      }
      this.$loadJS('https://webapi.amap.com/maps?v=2.0&key=f94794d8324cc241ee358e7985a6f2d3', () => {
        map = new window.AMap.Map('container', {
          center,
          zoom: 20,
          mapStyle: 'amap://styles/whitesmoke',
        });
        callback();
      });
    },
    // 初始化(谷歌地图)
    inintGoogleMap: function (cb) {
      cb = cb || function () {};
      const { center } = this.$getGMapCenterZoom();
      if (window.google) {
        map = new window.google.maps.Map(document.getElementById('container'), {
          center,
          zoom: 30,
          mapTypeId: 'roadmap',
        });
        cb();
        return;
      }
      this.$loadJS(`https://maps.googleapis.com/maps/api/js?key=AIzaSyCFJUNQ5om8G9WFr0TYMx4mA6-Gx7UiOYA&region=${this.mapRegion}&language=${this.mapLanguage}`, ({ google }) => {
        map = new google.maps.Map(document.getElementById('container'), {
          center,
          zoom: 15,
          mapTypeId: 'roadmap',
        });
        cb();
      });
    },
    /**
     * 初始化4个点
     * @param {Array<TargetPoint>} points
     */
    initPoints(points) {
      if (!points.length) {
        return;
      }

      // 根据纬度进行排序,方便用于错位布局
      points.sort((point1, point2) => point1.lnglat[1] - point2.lnglat[1]);

      const typeMap = this.typeMap;

      if (`${this.mapType}` === '4') {
        // 谷歌地图
        points.forEach((point) => {
          // eslint-disable-next-line no-unused-vars
          const marker = new window.google.maps.Marker({
            map,
            position: { lat: point.lnglat[1], lng: point.lnglat[0] },
            title: typeMap[point.type],
          });

          marker.addListener('click', () => {
            this.openGoogleInfoWindow(point, marker);
          });
        });

        // 设置第一个point为地图居中点
        map.setCenter({
          lat: points[0].lnglat[1],
          lng: points[0].lnglat[0],
        });
      } else if (`${this.mapType}` === '1') {
        // 高德地图
        points.forEach((point, index) => {
          const content = `<div class="map-marker ${(index + 1) % 2 === 0 ? 'even' : 'odd'}">
                             <div class="marker ${point.type}"></div>
                             <div class="point-info">
                                 <div class="point-type">${typeMap[point.type]}</div>
                                 <div class="address">${point.location}</div>
                             </div>
                         </div>`;
          // const content = `<div class="map-marker">
          //                      <div class="marker ${point.type}"></div>
          //                  </div>`;
          const marker = new window.AMap.Marker({
            content,
            position: point.lnglat,
            offset: new window.AMap.Pixel(-6, -6),
          });

          map.add(marker);
        });

        // 设置第一个point为地图居中点
        map.setCenter(points[0].lnglat);
      }
    },
    // 打开弹窗(谷歌地图)
    async openGoogleInfoWindow(item, marker) {
      if (showInfoWindow && showInfoWindow.close) {
        showInfoWindow.close();
      }
      const typeMap = this.typeMap;
      const content = `<div class="google-map-marker">
                             <div class="point-info">
                                 <div class="point-type">${typeMap[item.type]}</div>
                                 <div class="address">${item.location}</div>
                             </div>
                         </div>`;
      const infoWindow = new window.google.maps.InfoWindow({
        pixelOffset: { height: 100 },
        content: content,
      });
      showInfoWindow = infoWindow;
      infoWindow.open(map, marker);
    },
    /**
     * @typedef {Object} BasePoint
     * @property {Number} lng 经度
     * @property {Number} lat 纬度
     * @property {String} type point类型。start - 出发； arrive - 到达；solve - 解决；device - 机器
     */
    /**
     * @typedef {Object} TargetPoint
     * @property {Number} lng 经度
     * @property {Number} lat 纬度
     * @property {String} type point类型。start - 出发； arrive - 到达；solve - 解决；device - 机器
     * @property {Array<Number>} lnglat [lng, lat] 国际坐标=>中国坐标
     * @property {String} location 地址
     */
    /**
     * 格式化points,计算lnglat,location属性
     * @param {Array<BasePoint>} points
     * @return {Array<TargetPoint>} ret
     */
    async formatPoints(points) {
      points.forEach((item) => {
        const point = this.wgs_gcj_encrypts(item.lat, item.lng);
        item.lnglat = [point.lon, point.lat];
      });
      if (`${this.mapType}` === '4') {
        for (const point of points) {
          let position;
          // 国内/香港/澳门需要做坐标转换
          if (this.mapRegion === 'HK' || this.mapRegion === 'CN' || this.mapRegion === 'MO') {
            const wgs = { lon: point.lnglat[0], lat: point.lnglat[1] };
            position = { lat: wgs.lat, lng: wgs.lon };
          } else {
            position = { lat: point.lat, lng: point.lng };
          }
          if (!point.location) {
            point.location = (await this.getGoogleCode(position).catch(() => {})) || this.$t('asm_service_dynamic.wei_zhi_di_zhi');
          }
        }
      } else if (`${this.mapType}` === '1') {
        for (const point of points) {
          if (!point.location) {
            point.location = (await this.getGeoCode(point.lnglat).catch(() => {})) || this.$t('asm_service_dynamic.wei_zhi_di_zhi');
          }
        }
      }

      return points;
    },

    // 国际坐标=>中国坐标
    wgs_gcj_encrypts: function (wgLat, wgLon) {
      var point = {};
      if (this.outOfChina(wgLat, wgLon)) {
        point.lat = wgLat;
        point.lng = wgLon;
        return point;
      }
      var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
      var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
      var radLat = (wgLat / 180.0) * pi;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
      var lat = wgLat + dLat;
      var lon = wgLon + dLon;
      point.lat = lat;
      point.lon = lon;
      return point;
    },
    outOfChina(lat, lon) {
      if (lon < 72.004 || lon > 137.8347) {
        return true;
      }
      if (lat < 0.8293 || lat > 55.8271) {
        return true;
      }
      return false;
    },
    transformLon(x, y) {
      var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) * 2.0) / 3.0;
      return ret;
    },
    transformLat(x, y) {
      var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) / 3.0;
      ret += ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
      ret += ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) * 2.0) / 3.0;
      return ret;
    },
    // 逆地理编码(高德单个)
    getGeoCode: async function (lnglat) {
      return new Promise((resolve, reject) => {
        if (!lnglat) {
          reject();
          return;
        }
        window.AMap.plugin('AMap.Geocoder', () => {
          const Geocoder = new window.AMap.Geocoder();
          Geocoder.getAddress(lnglat, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              resolve(result.regeocode.formattedAddress);
            } else {
              reject();
            }
          });
        });
      });
    },
    // 逆地理编码(谷歌、单个)
    getGoogleCode: async function (item) {
      return new Promise((resolve, reject) => {
        if (!item.lat || !item.lng) {
          reject();
          return;
        }
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: new window.google.maps.LatLng(item.lat, item.lng) }, (results, status) => {
          // 这里处理结果和上面一模一样
          if (status === window.google.maps.GeocoderStatus.OK) {
            resolve(results[0].formatted_address);
          } else {
            reject();
          }
        });
      });
    },
    /**
     * 获取轨迹
     * @return {Promise} ret
     */
    getTrackList() {
      const reqUrl = `${apis.trackList}/${this.workOrderId}`;
      return this.$getJSON(reqUrl).then((res) => {
        const list = (res.data ? res.data.list : []) || [];
        return list;
      });
    },
    // 将机器信息和轨迹信息转为points
    getPoinst(deviceInfo, trackList) {
      const ret = [];
      // 机器
      if (deviceInfo.lng && deviceInfo.lat) {
        ret.push({
          lat: deviceInfo.lat,
          lng: deviceInfo.lng,
          type: 'device',
        });
      }

      // 出发
      const startPoint = trackList.find((item) => `${item.workOrderState}` === '60');
      if (startPoint) {
        if (startPoint.lng && startPoint.lat) {
          ret.push({
            lat: startPoint.lat,
            lng: startPoint.lng,
            type: 'start',
          });
        }
      }

      // 到达
      const arrivePoint = trackList.find((item) => `${item.workOrderState}` === '70');
      if (arrivePoint) {
        if (arrivePoint.lng && arrivePoint.lat) {
          ret.push({
            lat: arrivePoint.lat,
            lng: arrivePoint.lng,
            type: 'arrive',
          });
        }
      }

      // 解决
      const solvePoint = trackList.find((item) => `${item.workOrderState}` === '90');
      if (solvePoint) {
        if (solvePoint.lng && solvePoint.lat) {
          ret.push({
            lat: solvePoint.lat,
            lng: solvePoint.lng,
            type: 'solve',
          });
        }
      }

      return ret;
    },
  },
  mounted() {
    const langCode = Cookies.get('langCode') || 'CN';
    this.mapLanguage = languageMap[langCode];
    this.mapType = Cookies.get('mapType') || '1';
    this.mapRegion = Cookies.get('mapRegion') || 'HK';
    if (this.workOrderId) {
      setTimeout(() => {
        this.initMap(() => {
          this.getTrackList().then((trackList) => {
            const points = this.getPoinst(this.info, trackList);

            this.formatPoints(points).then((res) => {
              this.initPoints(res);
            });
          });
        });
      }, 500);
    }
    this.getStateList();
  },
};
</script>

<style lang="scss">
.google-map-marker {
  position: relative;
  z-index: 10;

  .point-info {
    width: 240px;
    font-size: 12px;
    position: relative;

    margin-left: 15px;

    .point-type {
      font-size: 14px;
      font-weight: bold;
    }
    .address {
      background: #fff;
      border: 1px solid #000;
      line-height: 15px;
      padding: 0 3px;
      margin-top: 5px;
    }
  }
}

.map-marker {
  position: relative;
  z-index: 10;
  width: 12px;
  height: 12px;

  &.even {
    .address {
      position: relative;
      left: -100%;
    }
  }
  .marker {
    margin: 0 auto;
    width: 12px;
    height: 12px;
    border: 2px solid #ffffff;
    border-radius: 6px;

    &.start {
      background: #16d071;
    }

    &.arrive {
      background: #f9c851;
    }

    &.solve {
      background: #ff5c5b;
    }

    &.device {
      background: #35b8e0;
    }
  }

  .point-info {
    width: 240px;
    font-size: 12px;
    position: relative;

    margin-left: 15px;
    margin-top: -15px;

    .point-type {
      font-size: 14px;
      font-weight: bold;
    }
    .address {
      background: #fff;
      border: 1px solid #000;
      line-height: 15px;
      padding: 0 3px;
    }
  }
}
</style>

<style lang="scss" scoped>
.service-dynamic {
  display: flex;
  height: 100%;
  .wrap-aside {
    width: 350px;
    // width: 100%;
    background-color: #ffffff;
    margin-left: 20px;
    padding-bottom: 10px;
    height: 100%;
    overflow: auto;
    .aside-title {
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
      color: #495057;
      font-weight: 500;
      font-size: 12px;
      border-bottom: 1px solid #eef2f8;
      margin-bottom: 10px;
    }
    .flow {
      padding: 25px 0 25px 32px;
      // height: 760px;
      overflow-y: auto;
      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
  .map-content {
    flex: 1;
    height: 100%;
    background: #ccc;
  }
}
</style>
